//This will add the dailymotion SDK if it has not already been loaded,
//then will call the dailyMotionOnPlayerReady.
function dailyMotionPlayVideo(videoId, autoplay, published_date, videovertical) {
  if (typeof window._DM === "undefined") {
    window.dmAsyncInit = function()
    {
      DM.init({ apiKey: '', status: false, cookie: false });
      //Code that ads event listener comes here
      dailyMotionOnPlayerReady(videoId, autoplay, published_date, videovertical);
    };
    (function() {
      var e = document.createElement('script');
      e.async = true;
      e.src = 'https://api.dmcdn.net/all.js';

      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(e, s);
    }());
  } else {
    dailyMotionOnPlayerReady(videoId, autoplay, published_date, videovertical);
  }
}

//Once the dailymotion library has been loaded, create a player and
//a listener to play next video
function dailyMotionOnPlayerReady(videoId, autoplay, published_date, videovertical) {
  var player = DM.player(document.getElementById('dmPlayer'), {
      video: videoId,
      params: {
          autoplay: autoplay
      }
  });

  player.addEventListener('end', function (e) {
      get_next_video(published_date, videovertical);
  });
}

//This will be called either the first time an entry is loaded or
//in the response of ajax.
function dailyMotionInit() {
  if ($('.dmPlayer').data('provider') === 'dailymotion') {
    var videoId = $('.dmPlayer').data('video-id');
    var autoplay = $('.dmPlayer').data('autoplay');
    var published_date = $(".dmPlayer").data("published");
    var videovertical = $(".dmPlayer").data("videovertical");
    dailyMotionPlayVideo(videoId, autoplay, published_date, videovertical);
  }
}

(function($){
    'use strict';
    dailyMotionInit();
})(jQuery);